import assistantConfiguration from './assistantConfiguration.json';
import chat from './chat.json';
import common from './common.json';
import database from './database.json';
import hub from './hub.json';
import instructions from './instructions.json';
import login from './login.json';
import management from './management.json';
import resource from './resource.json';
import updatePopup from './updatePopup.json';
import alerts from './alerts.json';
import errors from './errors.json';

const en = {
  assistantConfiguration,
  chat,
  common,
  database,
  hub,
  instructions,
  login,
  management,
  resource,
  updatePopup,
  alerts,
  errors,
};

export default en;
